(function () {
  'use strict';

  var SELECTORS = { widget: '.jpr-multi-widget' };
  var API_BASE  = 'https://api.judge.me/reviews/reviews_for_widget';

  // Same path as snippets/icon.liquid 'star-rating' / 'star-rating-empty'
  var STAR_PATH = 'm6.5 0 1.607 4.623 4.893.1-3.9 2.956 1.417 4.685L6.5 9.568l-4.017 2.796L3.9 7.679 0 4.723l4.893-.1L6.5 0Z';

  var LABELS = {
    verifiedBuyer:  'Achat vérifié',
    viewProduct:    'Voir le produit',
    prev:           'Précédent',
    next:           'Suivant',
  };

  // ── Helpers ──────────────────────────────────────────────────────────────────

  function _esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function _formatDate(iso) {
    try {
      return new Date(iso).toLocaleDateString('fr-FR', {
        year: 'numeric', month: 'long', day: 'numeric',
      });
    } catch (e) { return ''; }
  }

  // ── Rendering ─────────────────────────────────────────────────────────────────

  function _renderStars(rating) {
    var html = '';
    for (var i = 1; i <= 5; i++) {
      var opacityAttr = i <= rating ? '' : ' fill-opacity="0.4"';
      html +=
        '<svg aria-hidden="true" focusable="false" width="10" viewBox="0 0 13 13">' +
          '<path fill="currentColor"' + opacityAttr + ' d="' + STAR_PATH + '"/>' +
        '</svg>';
    }
    return (
      '<div class="testimonial-card__rating h-stack gap-3">' +
        '<div class="h-stack gap-0.5">' + html + '</div>' +
        '<span>' + rating + '/5</span>' +
      '</div>'
    );
  }

  function _buildCard(review, product) {
    var date     = _formatDate(review.created_at);
    var dateHtml = date ? '<span class="jpr-card__date">' + date + '</span>' : '';
    var verified = review.verified_buyer
      ? '<span class="jpr-card__verified">' + LABELS.verifiedBuyer + '</span>'
      : '';
    var metaHtml = (dateHtml || verified)
      ? '<div class="jpr-card__meta">' + dateHtml + verified + '</div>'
      : '';
    var footerHtml = product
      ? '<div class="testimonial-card__footer flex justify-between">' +
          '<p class="testimonial-card__product-title">' + _esc(product.title) + '</p>' +
          '<a href="' + _esc(product.url) + '" class="testimonial-card__product-link link">' +
            LABELS.viewProduct +
          '</a>' +
        '</div>'
      : '';

    return (
      '<article class="testimonial-card jpr-card">' +
        _renderStars(review.rating) +
        '<p class="testimonial-card__author">' + _esc(review.reviewer_name || '') + '</p>' +
        '<div class="testimonial-card__text">' + (review.body_html || '') + '</div>' +
        metaHtml +
        footerHtml +
      '</article>'
    );
  }

  // ── Slider ────────────────────────────────────────────────────────────────────

  function _buildSlider(items) {
    var slides = items.map(function (item) {
      return '<div class="jpr-slide">' + _buildCard(item.review, item.product) + '</div>';
    }).join('');

    return (
      '<div class="jpr-slider-wrapper">' +
        '<div class="jpr-slider" role="list">' + slides + '</div>' +
        '<button type="button" class="jpr-slider__btn jpr-slider__btn--prev" aria-label="' + LABELS.prev + '">&#8249;</button>' +
        '<button type="button" class="jpr-slider__btn jpr-slider__btn--next" aria-label="' + LABELS.next + '">&#8250;</button>' +
      '</div>'
    );
  }

  function _initSlider(wrapper) {
    var slider  = wrapper.querySelector('.jpr-slider');
    var prevBtn = wrapper.querySelector('.jpr-slider__btn--prev');
    var nextBtn = wrapper.querySelector('.jpr-slider__btn--next');
    if (!slider || !prevBtn || !nextBtn) return;

    function _scrollAmount() {
      var slide = slider.querySelector('.jpr-slide');
      return slide ? slide.offsetWidth + 16 : slider.clientWidth;
    }

    function _update() {
      var canScroll = slider.scrollWidth > slider.clientWidth + 1;
      wrapper.classList.toggle('jpr-slider--scrollable', canScroll);
      prevBtn.disabled = slider.scrollLeft <= 1;
      nextBtn.disabled = slider.scrollLeft >= slider.scrollWidth - slider.clientWidth - 1;
    }

    prevBtn.addEventListener('click', function () {
      slider.scrollBy({ left: -_scrollAmount(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      slider.scrollBy({ left: _scrollAmount(), behavior: 'smooth' });
    });
    slider.addEventListener('scroll', _update, { passive: true });
    window.addEventListener('resize', _update, { passive: true });
    // Defer initial check — browser needs one paint to calculate flex/percentage widths
    window.requestAnimationFrame(_update);
  }

  // ── Fetch ─────────────────────────────────────────────────────────────────────

  // Always fetch by date — client-side sort applied after merge (API doesn't support sort_key=rating)
  function _fetchForProduct(shopDomain, product, perProduct) {
    var url = API_BASE +
      '?shop_domain=' + encodeURIComponent(shopDomain) +
      '&product_id='  + encodeURIComponent(product.id) +
      '&platform=shopify' +
      '&per_page='    + perProduct +
      '&sort_key=date';

    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        return (data.reviews || []).map(function (rev) {
          return { review: rev, product: product };
        });
      })
      .catch(function () { return []; });
  }

  // ── Init ──────────────────────────────────────────────────────────────────────

  function _init() {
    var widg = document.querySelector(SELECTORS.widget);
    if (!widg) return;

    var scriptId    = widg.dataset.productsId;
    var shopDomain  = widg.dataset.shopDomain;
    var isMobile    = window.innerWidth < 700;
    var total       = isMobile
      ? (parseInt(widg.dataset.perPageMobile, 10) || 4)
      : (parseInt(widg.dataset.perPage, 10) || 6);
    var sortKey     = widg.dataset.sortKey || 'date';
    if (!scriptId || !shopDomain) return;

    var scriptEl = document.getElementById(scriptId);
    if (!scriptEl) return;

    var products;
    try { products = JSON.parse(scriptEl.textContent); } catch (e) { return; }
    if (!products || !products.length) return;

    widg.classList.add('jpr--loading');

    // Fetch a proportional share per product so no single product dominates the
    // merged result — each product gets at most ceil(total / numProducts) slots.
    var perProduct = Math.ceil(total / products.length);
    Promise.all(products.map(function (p) {
      return _fetchForProduct(shopDomain, p, perProduct);
    }))
    .then(function (results) {
      widg.classList.remove('jpr--loading');

      var all = [].concat.apply([], results);

      if (sortKey === 'rating') {
        all.sort(function (a, b) { return b.review.rating - a.review.rating; });
      } else {
        all.sort(function (a, b) {
          return new Date(b.review.created_at) - new Date(a.review.created_at);
        });
      }

      var top = all.slice(0, total);
      if (!top.length) {
        var section = widg.closest('.shopify-section');
        if (section) section.style.display = 'none';
        return;
      }

      widg.insertAdjacentHTML('beforeend', _buildSlider(top));
      _initSlider(widg.querySelector('.jpr-slider-wrapper'));
    })
    .catch(function () { widg.classList.remove('jpr--loading'); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _init);
  } else {
    _init();
  }
})();
